module.exports = __webpack_public_path__ + "media/bg3.640343d9.webm";